// import axios from 'axios'
import { DataService } from '@/services/DataService.js'

export const namespaced = true

// Для каждого отчета надо получать список доступных форм с бека
const defaultTypes = ['pdf', 'xlsx', 'docx', 'json', 'html']

export const state = {
  activeReport: null,
  reports: [{
    title: 'Эффективность работы компании на ЭТП',
    notes: 'При отсутствии данных за выбранный период будет сформирован пустой отчет.',
    templateId: 9,
    types: defaultTypes,
    fileName: 'efficiency',
    params: [{
      type: 'date_range',
      name: 'dates_range',
      start: 'date_start',
      end: 'date_end',
      title: 'диапазон дат'
    }]
  }, {
    title: 'Поданное предложение к тендеру',
    notes: 'Необходимо указать номер (tenderid) процедуры, по которой компания <span class="underline">подавала предложение</span>.',
    fileName: 'procedure_proposal',
    templateId: 5,
    types: defaultTypes,
    params: [{
      type: 'integer',
      name: 'tender_id',
      title: 'Номер процедуры'
    }]
  }]
}

export const getters = {
  reports (sate) {
    return state.reports
  },
  activeReport (state) {
    return state.activeReport
  }
}

export const mutations = {
  SET_ACTIVE_REPORT (state, report) {
    state.activeReport = report
  }
}

export const actions = {
  async renderActiveReport ({ commit, getters, rootGetters }) {
    const { templateId, type, params, fileName } = getters.activeReport
    commit('SET_ACTIVE_REPORT', { ...getters.activeReport, loading: true, error: null })
    DataService.generateReport({
      templateId: templateId,
      type: type,
      params: {
        ...params,
        company_id: rootGetters['user/user'].companyId
      }
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]))
      var fileLink = document.createElement('a')

      fileLink.href = fileURL
      fileLink.setAttribute('download', fileName + '.' + type)
      document.body.appendChild(fileLink)

      fileLink.click()
    }).catch((e) => {
      commit('SET_ACTIVE_REPORT', { ...getters.activeReport, error: e })
    }).finally(() => {
      commit('SET_ACTIVE_REPORT', { ...getters.activeReport, loading: false })
    })
  },
  setActiveReport ({ commit }, report) {
    commit('SET_ACTIVE_REPORT', report)
  }
}
